<template>	   
	<v-container>
	 	<v-card>
	 	 	<v-card-title primary-title>
	 	 		<h3 class="display-1">Categorias</h3>
	 	 	</v-card-title>
	 	 	<v-card-text>
	 	 		<v-text-field
	 	 		  name="search" solo
	 	 		  label="Buscar" append-icon="fa fa-search"
	 	 		  id="id" v-model="table.search"
	 	 		></v-text-field>
	 	 	 	<v-data-table
	 	 	 	   :headers="table.headers"
	 	 	 	   :items="table.items"
	 	 	 	   :loading="table.loading"
	 	 	 	   :search="table.search"
	 	 	 	   class="elevation-1" v-model="selected"
	 	 	 	   show-select
	 	 	 	   pagination.sync="pagination"
	 	 	 	   item-key="id"
	 	 	 	 >
	 	 	 	   	<template v-slot:item.actions="props">
	 	 	 	   		<td>
	 	 	 	   			<v-btn text color="warning" small fab @click="edit(props.item)"><v-icon>fa fa-pen</v-icon></v-btn>
	 	 	 	   			<v-btn text color="error" small fab @click="confirmDelete(props.item)"><v-icon>fa fa-trash</v-icon></v-btn>
	 	 	 	   		</td>
	 	 	 	   	</template>
	 	 	 	 </v-data-table> 
	 	 	</v-card-text>
	 	 	<v-card-actions>
	 	 	 	<v-btn color="success" @click="create()">Agregar nueva Categorias</v-btn> 
	 	 	</v-card-actions>
	 	</v-card>
	 	<v-dialog
	 	  v-model="modalCreate.active"
	 	  scrollable 
	 	  :overlay="false"
	 	  max-width="500px"
	 	  transition="dialog-transition"
	 	>
	 	  	<v-card>
	 	  	 	<v-card-title primary-title>
	 	  	 	  <h4 class="headline">Crear nueva Categorias</h4>
	 	  	 	</v-card-title>
	 	  	 	<v-card-text>
	 	  	 	 	  <v-text-field
	 	  	 	 	    name="name" required
	 	  	 	 	    label="Nombre" solo
	 	  	 	 	    v-model="modalCreate.data.name"
	 	  	 	 	  ></v-text-field>
	 	  	 	</v-card-text>
	 	  	 	<v-card-actions>
	 	  	 	 	<v-btn color="secondary" @click="modalCreate.active = false">Cancelar</v-btn>
	 	  	 	 	<v-spacer></v-spacer>
	 	  	 	 	<v-btn color="primary" @click="store()">Guardar</v-btn>
	 	  	 	</v-card-actions>
	 	  	</v-card>
	 	</v-dialog>
	 	<v-dialog
	 	  v-model="modalEdit.active"
	 	  scrollable 
	 	  :overlay="false"
	 	  max-width="500px"
	 	  transition="dialog-transition"
	 	>
	 	  <v-card>
	 	  	 	<v-card-title primary-title>
	 	  	 	  <h4 class="headline">Editar Categorias</h4>
	 	  	 	</v-card-title>
	 	  	 	<v-card-text>
						<v-form ref="edit" v-model="editCategory">
	 	  	 	 	  <v-text-field
	 	  	 	 	    name="name" required
	 	  	 	 	    label="Nombre" solo
	 	  	 	 	    v-model="modalEdit.data.name"
	 	  	 	 	  ></v-text-field>
	 	  	 	 	</v-form>	 	  	 	
	 	  	 	</v-card-text>
	 	  	 	<v-card-actions>
	 	  	 	 	<v-btn color="secondary" @click="modalEdit.active = false">Cancelar</v-btn>
	 	  	 	 	<v-spacer></v-spacer>
	 	  	 	 	<v-btn color="primary" @click="update()">Guardar</v-btn>
	 	  	 	</v-card-actions>
	 	  	</v-card>
	 	</v-dialog>
	 	<v-dialog
	 	  v-model="modalDelete.active"
	 	  scrollable  
	 	  :overlay="false"
	 	  max-width="500px"
	 	  transition="dialog-transition"
	 	>
	 	  	<v-card>
	 	  	 	<v-card-title primary-title>
	 	  	 	  <h4 class="headline">Borrar Categorias</h4>
	 	  	 	</v-card-title>
	 	  	 	<v-card-text>
	 	  	 	 	<p>¿ESTA SEGURO DE BORRAR Categorias?</p>
	 	  	 	</v-card-text>
	 	  	 	<v-card-actions>
	 	  	 	 	<v-btn color="secondary" @click="modalEdit.active = false">Cancelar</v-btn>
	 	  	 	 	<v-spacer></v-spacer>
	 	  	 	 	<v-btn color="primary" @click="deleteItem()">Confirmar</v-btn>
	 	  	 	</v-card-actions>
	 	  	</v-card>
	 	</v-dialog>
	 	<v-snackbar
	 	  v-model="alert.active"
	 	>
	 	 {{ alert.messague }}
	 	  <v-btn text :color="alert.color" @click.native="alert.active = false">Close</v-btn>
	 	</v-snackbar>
	</v-container>
</template>
<script>
	export default{
		created() {

		},
		mounted(){
			this.getData();
		},
		props: [
			'auth'
		],
		data(){
			return {
				createCategory: '',
				editCategory: '',
				baseRoute: process.env.VUE_APP_URL + 'api/gis/type',
				table: {
					items: [],
					headers: [],
					loading: true,
					search: ''
				},
				modalEdit: {
					active: false,
					data: {}
				},
				modalCreate: {
					active: false,
					data: {
						name: ''
					}
				},
				modalDelete: {
					active: false,
					data: {}
				},
				alert: {
					active: false,
					messague: "",
					color: "success"
				},
				selects: [],
				selected: []
			}
		},
		methods: {
			getData(){
				axios.get(this.baseRoute).then((res) => {
					this.table.loading = false;
					if(res.data == "Error"){
						this.alert.active = true;
						this.alert.messague = "Impsoble traer los datos";
						this.alert.color = "error";
					}else{
						this.table.items = res.data.items;
						this.table.headers = res.data.headers;
						this.selects = res.data.selects;
					}
				}).catch((error) => {
					this.table.loading = false;
					this.alert.active = true;
					this.alert.messague = "Hubó un error interno en el servidor contacte con el desarrollador";
					this.alert.color = "error";
				});
			},
			create(){
				this.modalCreate.active = true;
				this.modalCreate.data = {name: ''};
			},
			store(){
				axios.post(this.baseRoute + '/store', this.modalCreate.data).then((res) => {
					if(res.data != "Exito"){
						this.alert.active = true;
						this.alert.messague = "Los datos suministrados estan incompletos o no son validos";
						this.alert.color = "error";
					}else{
						this.alert.active = true;
						this.alert.messague = "Creado exitosamente";
						this.alert.color = "success";
						this.getData();
					}
				}).catch((error) => {
					this.alert.active = true;
					this.alert.messague = "Hubó un error interno en el servidor contacte con el desarrollador";
					this.alert.color = "error";
				});
			},
			edit(item){
				this.modalEdit.active = true;
				this.modalEdit.data = item;
			},
			update(){
				axios.put(this.baseRoute + '/update', this.modalEdit.data).then((res) => {
					if(res.data != "Exito"){
						this.alert.active = true;
						this.alert.messague = "Los datos suministrados estan incompletos o no son validos";
						this.alert.color = "error";
					}else{
						this.alert.active = true;
						this.alert.messague = "Actualizado correctamente";
						this.alert.color = "success";					
						this.getData();	
						
					}
				}).catch((error) => {
					this.alert.active = true;
					this.alert.messague = "Hubó un error interno en el servidor contacte con el desarrollador";
					this.alert.color = "error";
				});
			},
			confirmDelete(item){
				this.modalDelete.active = true;
				this.modalDelete.data = item;
			},
			deleteItem(){
				axios.post(this.baseRoute + '/destroy', this.modalDelete.data).then((res) => {
					if(res.data != "Exito"){
						this.alert.active = true;
						this.alert.messague = "Imposible de eliminar";
						this.alert.color = "error";
					}else{
						this.alert.active = true;
						this.alert.messague = "Eliminado correctamente";
						this.alert.color = "error";
						this.getData();
					}	
				}).catch((error) => {
					this.alert.active = true;
					this.alert.messague = "Hubó un error interno en el servidor contacte con el desarrollador";
					this.alert.color = "error";
				});
			},
		},
		watch: {

		},
		computed: {

		},
	}
</script>